import {
    GA_MEASUREMENT_ID,
    CLARITY_PROJECT_ID,
  } from "../config/analytics";
  
  export const initAnalytics = () => {
    // GOOGLE ANALYTICS
    if (GA_MEASUREMENT_ID && !window.gtag) {
      const script = document.createElement("script");
  
      script.async = true;
  
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  
      document.head.appendChild(script);
  
      window.dataLayer = window.dataLayer || [];
  
      function gtag() {
        window.dataLayer.push(arguments);
      }
  
      window.gtag = gtag;
  
      gtag("js", new Date());
  
      gtag("config", GA_MEASUREMENT_ID, {
        page_path: window.location.pathname,
      });
    }
  
    // MICROSOFT CLARITY
    if (CLARITY_PROJECT_ID && !window.clarity) {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
  
        t = l.createElement(r);
  
        t.async = 1;
  
        t.src = "https://www.clarity.ms/tag/" + i;
  
        y = l.getElementsByTagName(r)[0];
  
        y.parentNode.insertBefore(t, y);
      })(
        window,
        document,
        "clarity",
        "script",
        CLARITY_PROJECT_ID
      );
    }
  };
  
  export const trackPageView = (path) => {
    if (window.gtag && GA_MEASUREMENT_ID) {
      window.gtag("config", GA_MEASUREMENT_ID, {
        page_path: path,
      });
    }
  };
  
  export const trackEvent = (
    eventName,
    params = {}
  ) => {
    if (window.gtag) {
      window.gtag("event", eventName, params);
    }
  };